import debounce from "lodash-es/debounce";
import * as React from "react";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { RenderDiv } from "source/app/presentation/Shared/Render";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export const SearchDreams = ({ dreams }: { dreams: Dreams }) => {
    // Local state to debounce the search
    const [text, setText] = React.useState("");

    React.useEffect(() => {
        setText(dreams.state.searchText);
        UpdateDreamStateDebounced(dreams.state.searchText);
    }, [dreams.state.searchText]);

    return (
        <div
            className={StyleClass(`searchDreams_spacing`, {
                marginBottom: `15px`,
            })}
        >
            <FormInput
                id="target_searchDreams"
                label=""
                placeholder="search"
                maxWidth="500px"
                type="search"
                value={text}
                onChange={(event) => {
                    const searchText = event.target.value;
                    setText(searchText);
                    UpdateDreamStateDebounced(searchText);
                }}
                onClear={() => ClearDreamsState(dreams)}
                onFocus={() => ClearDreamsState(dreams)}
                dynamicOpacity
                classes={StyleClassAuto({
                    color: `white !important`,
                })}
            />
            <RenderDiv when={text !== ``} id="clearSearchDreamsTextLargeLink">
                <IconWithText
                    iconSuffix={EGlyphicon.remove}
                    whenClicked={() => ClearDreamsState(dreams)}
                    displayAsBlock
                >
                    Clear search
                </IconWithText>
            </RenderDiv>
        </div>
    );
};

function ClearDreamsState(dreams: Dreams) {
    const clearedDreamsState = {
        ...clearedDreamFilters,
        selectedDifficulty: 5,
        randomDream: undefined,
    };

    dreams.setState(clearedDreamsState);

    console.log(`[SearchDreams] cleared Dreams state`);
}

const UpdateDreamState = (searchText: string) => {
    console.log(`[Dreams] setting searchText to '${searchText}'`);
    
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);
    const existingState = dreams.state;

    if (dreams) {
        dreams.setState({ ...existingState, searchText });
    }
};

const UpdateDreamStateDebounced = debounce(
    UpdateDreamState,
    400
);
